import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactCrop from 'react-image-crop';

import 'react-image-crop/dist/ReactCrop.css';

import { Button } from 'evee-ui-common/components/base';

import DefaultDialog from 'widgets/layout/DefaultDialog';

const getDefaultCropSettings = (circular = false) => ({
  aspect: circular ? 1 : 3 / 2,
  unit: '%',
  width: 100,
});

const getCroppedImg = (src, crop, asBlob = false) =>
  new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const image = new Image();
    image.onload = () => {
      const scaleX = image.naturalWidth / 100;
      const scaleY = image.naturalHeight / 100;
      const ctx = canvas.getContext('2d');
      const sx = crop.x * scaleX;
      const sy = crop.y * scaleY;
      const sw = crop.width * scaleX;
      const sh = crop.height * scaleY;
      canvas.width = sw;
      canvas.height = sh;
      ctx.drawImage(image, sx, sy, sw, sh, 0, 0, sw, sh);

      if (asBlob) {
        canvas.toBlob(
          (result) => {
            resolve(result.arrayBuffer());
          },
          'image/jpeg',
          process.env.REACT_APP_CROPPED_IMAGE_QUALITY,
        );
        return;
      }

      resolve(canvas.toDataURL('image/jpeg', process.env.REACT_APP_CROPPED_IMAGE_QUALITY));
    };
    image.src = src;
  });

const PhotoCrop = ({ src, open, circularCrop, buttonText, asBlob, onComplete }) => {
  const [crop, setCrop] = useState();

  useEffect(() => {
    const defaultCrop = getDefaultCropSettings(circularCrop);
    setCrop(defaultCrop);
  }, [src, circularCrop]);

  return (
    <DefaultDialog
      open={open}
      renderActions={() => (
        <Button
          text={buttonText}
          size="large"
          style={{ width: '100%' }}
          onClick={async () => {
            const result = await getCroppedImg(src, crop, asBlob);
            onComplete(result);
          }}
        />
      )}
      onClose={() => onComplete(null)}
    >
      <ReactCrop
        circularCrop={circularCrop}
        src={src}
        crop={crop}
        onChange={(newCrop, percentCrop) => setCrop(percentCrop)}
      />
    </DefaultDialog>
  );
};

PhotoCrop.propTypes = {
  src: PropTypes.string.isRequired,
  open: PropTypes.bool,
  circularCrop: PropTypes.bool,
  buttonText: PropTypes.string,
  asBlob: PropTypes.bool,
  onComplete: PropTypes.func,
};

PhotoCrop.defaultProps = {
  open: false,
  circularCrop: false,
  buttonText: 'Complete',
  asBlob: false,
  onComplete: () => {},
};

export default PhotoCrop;
